import { Navbar, Nav, Container } from "react-bootstrap";
import "./Navs.css";
import logo from "./../../assets/logo.png";
const Navs = () => {
  return (
    <Navbar expand="lg">
      <Container>
        <Navbar.Brand href="#home">
          <img src={logo} alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link href="#home">Home</Nav.Link>
            <Nav.Link href="#link">About Us</Nav.Link>
            <Nav.Link href="#link">Explore Food</Nav.Link>
            <Nav.Link href="#link">Reveiw</Nav.Link>
            <Nav.Link href="#link">Faq</Nav.Link>
          </Nav>
          <Nav>
            <Nav.Link className="last-nav" href="">
              01123838278
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navs;
